import { useMutation, useQuery } from '@tanstack/react-query'
import { longStaleTime, type GenericQueryOptions } from '.'
import apiClient from '../Utils/apiClient'

import type { PersonAdditionalData } from '../dtos'

const baseUrl = import.meta.env.VITE_BASE_URL
const personApiUrl = import.meta.env.VITE_PERSON_API
const url = `${baseUrl}/${personApiUrl}`

export const useGetBirthdate = (birthnumber?: string | null, options?: GenericQueryOptions<Date>) =>
    useQuery({
        queryKey: ['useGetBirthdate', birthnumber],
        queryFn: () => apiClient.get<Date>(`${url}/GetBirthdateFromBirthnumber?birthnumber=${birthnumber}`),
        staleTime: longStaleTime,
        ...options
    })

export const useFindPerson = () =>
    useMutation({
        mutationFn: (birthnumber?: string) =>
            apiClient.post<PersonAdditionalData>(`${url}/FindPerson`, null, { params: { birthnumber } }).then(res => res.data)
    })

export const useFindCompany = () =>
    useMutation({
        mutationFn: (ico?: string) =>
            apiClient.post<PersonAdditionalData>(`${url}/FindCompany`, null, { params: { ico } }).then(res => res.data)
    })